import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/kit";
import { TodayTable, AbsenceManager, MonthReport } from "@/components/Attendance";
import { TimesheetPicker } from "@/components/Timesheet";
import { PROFILES } from "@/data/mock";

export default function OwnerAttendance() {
  const cid = PROFILES.empresaria.companyId;
  return (
    <div data-testid="owner-attendance-page">
      <PageHeader eyebrow="Pessoas" title="Jornada e presença" subtitle="Acompanhe início, pausas e término da jornada, registre faltas, férias e afastamentos e veja o relatório de desempenho." />
      <Tabs defaultValue="hoje">
        <TabsList className="h-auto flex-wrap justify-start bg-neutral-100 p-1 print:hidden">
          <TabsTrigger value="hoje" data-testid="attendance-tab-today" className="data-[state=active]:bg-white">Hoje</TabsTrigger>
          <TabsTrigger value="ausencias" data-testid="attendance-tab-absences" className="data-[state=active]:bg-white">Ausências</TabsTrigger>
          <TabsTrigger value="relatorio" data-testid="attendance-tab-report" className="data-[state=active]:bg-white">Relatório do mês</TabsTrigger>
          <TabsTrigger value="espelho" data-testid="attendance-tab-timesheet" className="data-[state=active]:bg-white">Espelho de ponto</TabsTrigger>
        </TabsList>
        <TabsContent value="hoje" className="mt-6"><TodayTable companyId={cid} canMark /></TabsContent>
        <TabsContent value="ausencias" className="mt-6"><AbsenceManager companyId={cid} /></TabsContent>
        <TabsContent value="relatorio" className="mt-6"><MonthReport companyId={cid} /></TabsContent>
        <TabsContent value="espelho" className="mt-6"><TimesheetPicker companyId={cid} /></TabsContent>
      </Tabs>
    </div>
  );
}
